import cx from "classnames";

import Tooltip from "ds/components/Tooltip";
import Icon, { IconProps } from "ds/components/Icon";

type IconWithTooltipProps = {
  icon: IconProps["src"];
  tooltip: string;
  className?: string;
  size?: IconProps["size"];
  noShrink?: IconProps["noShrink"];
};

const IconWithTooltip = ({ icon, tooltip, className, size, noShrink }: IconWithTooltipProps) => {
  return (
    <Tooltip
      on={(props) => (
        <Icon
          aria-label={tooltip}
          aria-hidden={false}
          src={icon}
          size={size}
          noShrink={noShrink}
          {...props}
          className={cx(className, props.className)}
        />
      )}
    >
      {tooltip}
    </Tooltip>
  );
};

export default IconWithTooltip;
